<template>
  <div class="not-found-page">
    <div class="content">
      <h1>404</h1>
      <p>The page you're looking for doesn't exist or has moved.</p>
      <router-link class="home-link" :to="dashboardRoute"
        >Go to Dashboard</router-link
      >
      <router-link class="home-link alt" to="/">Return to Sign In</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  computed: {
    dashboardRoute() {
      return { name: "Catalog" };
    }
  }
};
</script>

<style scoped lang="scss">
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: radial-gradient(circle at center, #111 0%, #000 80%);
  color: #fff;
  padding: 2rem;

  .content {
    max-width: 520px;
  }

  h1 {
    font-size: clamp(4rem, 15vw, 9rem);
    margin: 0 0 1rem;
    line-height: 1;
    background: linear-gradient(90deg, #ff6a3d, #ff974d, #ff6a3d);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 1.125rem;
    line-height: 1.5;
    margin-bottom: 2rem;
    opacity: 0.8;
  }

  .home-link {
    display: inline-block;
    margin: 0 0.75rem 0.75rem;
    padding: 0.75rem 1.5rem;
    border-radius: 30px;
    background: linear-gradient(135deg, #ff6a3d, #cc4f2c);
    color: #fff;
    text-decoration: none;
    font-weight: 600;
    letter-spacing: 0.5px;
    transition: all 0.25s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px -8px rgba(255, 106, 61, 0.6);
    }

    &.alt {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
